
<div class="message-hide" [class.message-show]="isTrueURL">{{messageInvalidURL}}</div>
<div class="message-hide" [class.message-show]="isSuccessEmail">{{errorMessageSuccess}}</div>
<div class="message-hide" [class.message-show]="isActivateEmail" >{{errorMessageActivate}}</div>

